import styled from "styled-components"

export const ArrowButton = styled.button`
  appearance: none;
  display: inline-block;
  cursor: pointer;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  background-color: transparent;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: 10px;
  text-indent: -9999px;
`
